<template>
	<v-navigation-drawer
		:value="visible"
		absolute right
		temporary disable-route-watcher
		@input="close($event)"
		class="background darken-1">
		<v-card v-if="asset" class="background elevation-0">
			<v-card-title class="pa-2 title">
				<v-btn
					flat icon
					@click="$emit('close')"
					class="ma-0 mr-3">
					<v-icon>close</v-icon>
				</v-btn>
				{{ asset.ref_material }} | {{ asset.id }}
			</v-card-title>
			<v-card-text class="background darken-1 pa-0">
				<Asset :asset="asset">
				</Asset>
			</v-card-text>
		</v-card>
	</v-navigation-drawer>
</template>

<script>
import Asset from '@/components/asset.vue'
export default {
	props: [
		'visible',
		'asset'
	],
	components: { Asset },
	methods: {
		close (visible) {
			if (!visible) this.$emit('close')
		}
	}
}
</script>

<style lang="stylus" scoped>
.v-navigation-drawer--open
	width: 50% !important
	min-width: 1024px
</style>



// WEBPACK FOOTER //
// src/pages/filesystem/title_asset_finder_asset_drawer.vue